import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';

@Component({
  selector: 'lc-zoom-afspraakpage',
  templateUrl: './zoom-afspraakpage.component.html',
  styleUrls: ['./zoom-afspraakpage.component.scss']
})
export class ZoomAfspraakPageComponent implements OnInit {

  user_code_ph: string;
  loading: boolean = false;
  completed: boolean = false;
  show_request_form: boolean = false;
  show_demo_popup: boolean = false;
  request_type: string;
  field_map: any = {
    address: "fieldjruyyky",
    city: "fieldjruyykt",
    company: "fieldjruyykr",
    email: "fieldEmail",
    function: "fieldiruivl",
    request_type: "fieldirutudu",
    info: "5883852",
    demo: "5883852",
    // ext_id: "717273",
    // phone: "00786191196"
    postalcode: 'fieldjruyykj'
  }


  constructor(public dataService: DataService) { }

  ngOnInit() {
    this.completed = !!document.location.search && document.location.search.indexOf('completed=true') > -1;
    try {
      let stored_request_type = window.sessionStorage.getItem("request_type");
      if( !!stored_request_type ){
        window.sessionStorage.removeItem("request_type");
        if( stored_request_type === 'taart' ){
          window.location.href = window.location.href.replace('zoomafspraak', 'gefeliciteerd');
        }
      }
    } catch(e){

    }
  }

  show_form(type){
    this.show_request_form = true;
    this.request_type = type;
    // // set the (hidden) field
    // setTimeout(() => {
    //   document.getElementById(this.field_map.request_type)['value'] = this.field_map[type];
    // },200)
  }

  close_form(){
    this.show_request_form = false;
  }
  
  open_popup(){
    this.show_demo_popup = true;
  }

  close_popup(){
    this.show_demo_popup = false;
  }
  // this function takes the user code and sets user status. Returns a result or error from the server
  check_code(){
    let code = this.user_code_ph;
    this.dataService.getUserForCode(code).subscribe(
      (client) => {
        // console.log(client);
        if(!!client.error){
            this.dataService.presentMessage('Oeps. Het lijkt erop dat deze klantcode niet bestaat.', 'error');
        }
        else {
          // this.user_info = client;
          this.dataService.user_info = client;
          for(const k in client){
            const f_id = this.field_map[k];
            if( !!f_id ){
              document.getElementById(f_id)['value'] = client[k];
            }
          }
          // this.goToShop(); // we know the user now, let's forward.
          // this.dataService.saveUserInfo(this.dataService.subuser_info);
          // if(!!client.language && !this.new_user.language){
          //   this.new_user.language = client.language;
          //   this.dataService.set_language(client.language.toLowerCase())
          // }
        }
    },
    (err) => {
      this.dataService.presentMessage('Oeps. Het lijkt er op dat er iets mis is gegaan bij het controleren van de code. Weet je zeker dat de code juist is?','error');
    },
    () => {
      console.debug('done getting code information');
    }
    )
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/zoom-afspraakpage/zoom-afspraakpage.component.ts